import { useMemo } from "react";
import { CountriesAllowed } from "v3/services/graphql/generated";

interface UseCountryOnLoad {
  countriesAllowed: CountriesAllowed[];
  countryCode?: string | null;
}

export const useCountryOnLoad = ({
  countriesAllowed,
  countryCode,
}: UseCountryOnLoad) => {
  const countryOnLoad = useMemo(() => {
    // if a countryCode is given, use that first
    // otherwise if US in countriesAllowed, show that
    // otherwise pick value from first country in countriesAllowed array
    const isUSAllowed = countriesAllowed.some((country) => country.id === "US");
    return countryCode || (isUSAllowed ? "US" : countriesAllowed[0].id) || "US";
  }, [countryCode, countriesAllowed]);

  return { countryOnLoad };
};
